/**
 * The TwoCoins mark: one coin pulled apart, not two coins together.
 *
 * The gap between the halves IS the product — what's yours on one side, what
 * you already promised on the other. Closing it breaks the idea, not just the
 * drawing, so the two paths are never merged and never overlapped.
 *
 * Two colourways only, per the brand kit: navy + amber on light, cream + amber
 * on dark. No single-colour version, no gradient. Amber is the constant half.
 *
 * Minimum size is 20px — below that the gap closes up and it reads as one
 * blob, which is the one thing the mark must never do.
 */
const MIN_SIZE = 20;

interface LogoProps {
  size?: number;
  /**
   * Accessible name. Omit it wherever the mark sits next to the wordmark, so
   * a screen reader announces "TwoCoins" once rather than twice.
   */
  title?: string;
}

export function Logo({ size = 26, title }: LogoProps) {
  const rendered = Math.max(size, MIN_SIZE);

  return (
    <svg
      width={rendered}
      height={rendered}
      viewBox="0 0 40 40"
      fill="none"
      role={title ? 'img' : 'presentation'}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      style={{ flex: 'none' }}
    >
      {title ? <title>{title}</title> : null}
      {/* Yours */}
      <path d="M18.5 5A15 15 0 0 0 18.5 35Z" fill="var(--mark-half)" />
      {/* Committed */}
      <path d="M21.5 5A15 15 0 0 1 21.5 35Z" fill="var(--mark-accent)" />
    </svg>
  );
}
